/** Normalize paginated product list API payload. */
export function parseProductListResponse(res) {
  const body = res?.data;
  const pagination = body?.pagination;
  const data = body?.data ?? body;

  const products =
    data?.products ??
    data?.product_list ??
    data?.productList ??
    data?.list ??
    (Array.isArray(data) ? data : []);

  const list = Array.isArray(products) ? products : [];

  const total =
    pagination?.total ??
    pagination?.total_count ??
    pagination?.totalCount ??
    data?.total ??
    data?.total_count ??
    data?.totalCount ??
    data?.count ??
    body?.total ??
    list.length;

  const currentPage = Number(pagination?.page) || 1;
  const totalPages = Number(pagination?.total_pages) || 1;

  return {
    products: list,
    total: Number(total) || 0,
    currentPage,
    totalPages
  };
}
